import React from "react";
import { useParams, Link } from "react-router-dom";
import cookie from "js-cookie";
import Sidebar from "../../../partials/aside/Sidebar";
import AddCategoryUserSitePublisher from "./AddCategoryUserSitePublisher";
import actionCookie from "../../../../helpers/action-cookie";
import TitleBar from "../../../partials/content/TitleBar";

export default function AddCategoryUserSitePublisherContainer() {
  cookie.set(
    actionCookie.REF_ENTER_ADD_GROUP_SITE_PUBLISHER,
    actionCookie.REF_ENTER_ADD_GROUP_SITE_PUBLISHER_VALUE_ADD_GROUP
  );

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="اضافه کردن گروه نمایش دهنده بنری" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-3">
                <Link to="/publishers/coworker/" className="btn btn-primary">
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>

              <AddCategoryUserSitePublisher />
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
